import React from 'react';
import cls from './EmptyMeasurementsList.module.css';

export const EmptyMeasurementsList = () => {
    return (
        <div className={cls.EmptyMeasurementsList}>
            <h1>
                {i18next.t('EmptyMeasurementsList.return.h1.part1')}
                <br />
                {i18next.t('EmptyMeasurementsList.return.h1.part2')}
            </h1>
            <p>{i18next.t('EmptyMeasurementsList.return.instruction')}</p>
        </div>
    );
};
